import { THETAN_BOX_PAYMENT_ADDRESS } from '@wolffun/shared/constants';
import { getCurrentConnector, walletClient } from '@wolffun/shared/src/utils/walletClient';
const address = THETAN_BOX_PAYMENT_ADDRESS;
const abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'previousOwner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'OwnershipTransferred',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'buyer',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'boxType',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'paymentToken',
    type: 'address'
  }],
  name: 'ThetanBoxPaid',
  type: 'event'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'boxType',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'paymentErc20',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'signature',
    type: 'bytes'
  }],
  name: 'buyBoxFreeWithSignature',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'boxType',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'paymentErc20',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'signature',
    type: 'bytes'
  }],
  name: 'buyBoxWithSignature',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'boxType',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'user',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'paymentErc20',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'expiredAt',
    type: 'uint256'
  }],
  name: 'getBuyBoxMessageHash',
  outputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  stateMutability: 'pure',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  name: 'ids',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'owner',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'paymentReceivedAddress',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'renounceOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_paymentReceivedAddress',
    type: 'address'
  }],
  name: 'setPaymentReceivedAddress',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }],
  name: 'setSigner',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'signer',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'transferOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'boxType',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'price',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'paymentErc20',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'expiredAt',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'signature',
    type: 'bytes'
  }],
  name: 'verifyBuyBoxSignature',
  outputs: [],
  stateMutability: 'view',
  type: 'function'
}];

const getContract = () => {
  if (walletClient) {
    return getCurrentConnector().getContract({
      address,
      contractInterface: abi
    });
  }

  return undefined;
};

export default {
  address,
  abi,
  getContract
};